function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import get from 'lodash/get';
import unset from 'lodash/unset';
import includes from 'lodash/includes';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Validator from 'libs/Validator';
import Form from 'components/Form';
import FormGroup from 'components/Form/FormGroup';
import Input from 'components/Form/Input';
import Button from 'components/Form/Button';
import FormContainerAbstract from 'components/FormContainerAbstract';
import App from 'modules/App';
import messages from '../../../../../messages';
import * as constants from '../../../../../constants';
import validatorRules from './validatorRules.json';
import styles from './AddPayerForm.pcss';
class AddPayerForm extends FormContainerAbstract {
    onValidate(rules) {
        const values = get(this.props.formValues, 'values', {});
        const { errors } = Validator.run(values, rules);
        if (values.name && !includes(this.props.payers, values.name)) {
            unset(errors, 'name.alreadyExist');
        }
        if (errors && errors.name && !Object.keys(errors.name).length) {
            unset(errors, 'name');
        }
        return {
            validatedValues: values,
            errors: !errors || Object.keys(errors).length ? errors : null
        };
    }
    renderHeader() {
        return /*#__PURE__*/ _jsx("div", {
            children: /*#__PURE__*/ _jsx("p", {
                className: "mb-6",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.addNewPayer))
            })
        });
    }
    renderActions() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "row",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-6",
                    children: /*#__PURE__*/ _jsx(Button, {
                        type: "reset",
                        styleModifier: "primary",
                        labelMessage: App.messages.buttons.cancel,
                        className: "btn--block",
                        onClick: this.props.onClose
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-6",
                    children: /*#__PURE__*/ _jsx(Button, {
                        type: "submit",
                        styleModifier: "primary",
                        labelMessage: messages.buttons.addPayer,
                        className: "btn--block btn--filled",
                        isDisabled: this.isDisabled,
                        isInProgress: this.state.isInProgress
                    })
                })
            ]
        });
    }
    renderForm() {
        return /*#__PURE__*/ _jsxs(Form, {
            className: styles.addCountryForm,
            onSubmit: ()=>this.onSubmit(),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "row",
                    children: /*#__PURE__*/ _jsx(FormGroup, {
                        id: "name",
                        className: "col",
                        labelMessage: messages.labels.payerName,
                        formValues: this.props.formValues,
                        children: /*#__PURE__*/ _jsx(Input, {
                            placeholder: messages.placeholders.addPayer,
                            onChange: (input)=>this.onSetValue(input)
                        })
                    })
                }),
                this.renderActions()
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                this.renderHeader(),
                this.renderForm()
            ]
        });
    }
    constructor(props){
        super(props);
        this.validatorRules = _object_spread({}, validatorRules);
        this.state = {
            isInProgress: false
        };
    }
}
_define_property(AddPayerForm, "propTypes", _object_spread_props(_object_spread({}, FormContainerAbstract.propTypes), {
    // Explicit props
    payers: PropTypes.array,
    // Explicit actions
    onClose: PropTypes.func,
    onAddPayer: PropTypes.func
}));
const mapStateToProps = (state)=>({
        formValues: App.selectors.formSelector(constants.ADD_PAYER_FORM)(state)
    });
const mapDispatchToProps = (dispatch)=>{
    const formName = constants.ADD_PAYER_FORM;
    return {
        onSetFormValue: (input)=>dispatch(App.actions.setFormValue(formName, input)),
        onSetFormValues: (values)=>dispatch(App.actions.setFormValues(formName, values)),
        onFormErrors: (errors)=>dispatch(App.actions.setFormErrors(formName, errors)),
        onFormProcessing: ()=>dispatch(App.actions.startFormProcessing(formName)),
        onClearForm: ()=>dispatch(App.actions.clearForm(formName))
    };
};
const ConnectedAddPayerForm = connect(mapStateToProps, mapDispatchToProps)(AddPayerForm);
export default withStyles(styles)(ConnectedAddPayerForm);
